import { Box } from '@chakra-ui/react';

/**
 * How much of what this month needs is already saved, as a ring with the share
 * in its middle. Shared by the goals page's month card and the dashboard card,
 * so the two never disagree.
 */
export default function GoalMonthRing({ pct, size = 76, stroke = 7 }) {
  const shown = Math.min(100, Math.max(0, pct || 0));
  const radius = (size - stroke) / 2 - 1;
  const center = size / 2;
  const circumference = 2 * Math.PI * radius;

  return (
    <Box as="svg" w={`${size}px`} h={`${size}px`} viewBox={`0 0 ${size} ${size}`} flexShrink={0}>
      <Box as="circle" cx={center} cy={center} r={radius} fill="none" stroke="var(--chakra-colors-redesign-bg-sunken)" strokeWidth={stroke} />
      <Box
        as="circle"
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke="var(--chakra-colors-redesign-accent-green)"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={`${(shown / 100) * circumference} ${circumference}`}
        transform={`rotate(-90 ${center} ${center})`}
      />
      <Box as="text" x={center} y={center + size * 0.065} textAnchor="middle" fontSize={`${Math.round(size * 0.21)}px`} fontWeight="600" fill="var(--chakra-colors-redesign-heading)">
        {Math.round(shown)}%
      </Box>
    </Box>
  );
}
